import { render, staticRenderFns } from "./TefConfigTerminals.vue?vue&type=template&id=27dd33e3&"
import script from "./TefConfigTerminals.vue?vue&type=script&lang=js&"
export * from "./TefConfigTerminals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports